import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import About_Us from "./components/about-us/About_Us";
import Tour_Packages from "./components/tour-packages/Tour_Packages";
import Tour_Details from "./components/tour-packages/our-packages/tour-details/Tour_Details";
import Faq from "./components/faq/Faq";
import Blogs from "./components/blogs/Blogs";
import Blog_Details from "./components/blogs/blog-details/Blog_Details";
import Booking_Details from "./components/home/banner/booking-details/Booking_Details";
import Contact_Us from "./components/contact-us/Contact_Us";
import ScrollToTop from "./scrolltotop/ScrollToTop";
import Terms_Of_Services from "./components/terms-of-services/Terms_Of_Services";
import Privacy_Policy from "./components/privacy-policy/Privacy_Policy";

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About_Us />} />
        <Route path="/tour-packages" element={<Tour_Packages />} />
        <Route path="/tour-details/:id" element={<Tour_Details />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog/:id" element={<Blog_Details />} />
        <Route path="/booking-details/:id" element={<Booking_Details />} />
        <Route path="/contact-us" element={<Contact_Us />} />
        <Route path="/terms-condition" element={<Terms_Of_Services />} />
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
